import { sendLogs as apiLogger } from 'api';
import throttle from 'lodash/throttle';

let events: any[] = [];

const sendLogs = throttle(
  async () => {
    const pendingEvents = [...events];
    events = [];

    apiLogger({ logs: pendingEvents });
  },
  1500,
  { leading: false },
);

export function log(event: any) {
  events.push(event);

  sendLogs();
}

export const isDebug = window.location.search.includes('debug-front');

export const isTraceJitsi = isDebug || window.location.search.includes('trace-jitsi');
